export const PC_PLAYERS = [
    ['84867c4ef9674c9b838b0c9c815a58fc', '291635110372020224', "gw baxo 8"],
    ['2c47f443d99c4f8fabeae06f3c829577', '660936525206265856', "cloud noe mvp"],
    ['fbe1c859486d40a788ff86e4c224b171', '182320951394930688', "NTO Bidou"],
    ['919b84060a7f4f689a89493f89f6f434', '412253044097519616', "Yernix_Le_Bavard"],
    ['1dd643484bc143088a1d476671e2e207', '182326865904635904', "avora i lovenico"],
    ['6fb5dc4e90e6424dbd550e94ec5d06d3', '247045366099316736', "i love novax"],
    ['c03ea2954da64584ab9ca3ba705395ae', '128427982904639488', "Sami 216ǃ"],
    ['74d33a5f52454dd6855091fa80480c74', '163646779567386624', "Aura donald"],
    ['eff33be4774d432b8657210586c1dd18', '182270214845599744', "Wiiphix 212"],
    ['60d5b54506854f69be9e2f6c626f531e', '184711512634527745', "Rizmo 212"],
    ['e5081a4c0eea4863b8bedea95aadca2f', '229585553174138880', "BK ROG Kaiser"],
    ['c16ec4b039f34c939e64034cdf88f196', '609374813554753536', "ns extazeǃ"],
    ['2dedde2f9ff842d799252b4c9285e96b', '120560039030173696', "Flawless Nejiiǃ"],
    ['d507ec72bdd6493db72a2edc99c62726', '368778180443607040', "NVK suires"],
    ['c8f25a8a3bcc4f8c9290c627f655290c', '127468327269318656', "Shiwey_"],
    ['c86d2c3a398c4e3a9898978ff5ce9949', '184708126648406016', "exa traydox"],
    ['accf4d615a42400a9f43fabd2c48de48', '109251290126626816', "sky splikǃ"],
    ['70a8b05d217d47a381e9137b9a0dce51', '126360523179569152', "iceechocovanille"],
    ['7a3b2792dfb640b09968ec21e4a24808', '234617431870509056', "Nayrøxx fvǃ"],
    ['f298dfd76dbe4046a5b44f5e853025af', '503265513464414208', "Rysefvǃ"],
    ['9ae9627bbf074fae86da62eda2bfe363', '300320209464561667', "Twitch ZAYREYLI"],
    ['9cec6bc2acd54e7b9ba07d816a51cfae', '331487607252946944', "VIRA Hquex"],
    ['0d2a11c986e84965810162b729f08f20', '163983817554538496', "ORG 1 pas 2"],
    ['c48fcc8a34c1429eb1c9f787253084b0', '218090030986530816', "ORG neyvox bää ǃ"],
    ['41c58c33c5904bd9a680ff6a3682e4c4', '184346761425424384', "rabzzxdd"],
    ['a61b41ff27c5444c9de0be61cbf5b85b', '177893113279385601', "Noafvǃ"],
    ['34e450b965644782968a464a6b2f588d', '177898427072483328', "graissedebidoufv"],
];

export const CONSOLE_PLAYERS = [
    ['17ab035f374440da9542d9c50edefde4', '182302838892892162', "ORA Нирокс"],
    ['a91d2c9039924e059ddae174f6e4ed25', '414487571133992961', "R4C Chasseur"],
    ['5edc96b82fcf4c62a924e8f703373278', '180691581404196864', "askaaǃ"],
    ['88260f61d58749c5850b88bf0eaf341f', '460133553083092992', "UraharaKisuke9.9"],
    ['6839a17f7985496b84a3535c10723125', '204997222767628288', "klaydfn1"],
    ['222b9235e1f04c4d948708722bb05348', '149607926036705280', "NTO Vyn 93"],
    ['a0735f0a0cf146babd65bc3773e78323', '169015826345635840', "Afox Tchiki BRRR"],
    ['76fc4cd239554e05a2230b4c80afec59', '182267254858158080', "ALLAHǃǃ"],
    ['d72c1a1a89f24fd68a826790968d615c', '182293207776858115', "Veyo l abricot"],
    ['628f389dda1c450888adebc7397f1934', '660147254513946624', "3 singe"],
    ['96415b6b84714c64ad9421bcf429866b', '217680705122045952', "focuss 7ǃ"],
    ['9155e19ba5b64f3c8e703e68fa9e8b73', '658277736665583616', "Vira Hmzz"],
    ['e1df4958091d40b7b5891fdd5d71ab76', '411247288632053760', "Twitch plixfn1"],
    ['eadd3999a3f14665acfa196efd938d02', '615355677484785664', "Ahkamm 1st"],
    ['a638bfac41f84c629cdcca098c28a3f7', '172366974507036672', "Kagamifv."],
    ['6ea12672f47647d7aa4cb3198cd14bc2', '204284169902198784', "F3eyko3x"],
    ['dfc8e0dba4934217a451ee97ed55165c', '290173351920504832', "EQY rayzenfv"],
    ['cbb237ca24ee4ea8904668a84ec7c5af', '534803479697309696', "EQY nozixx 7"],
    ['bc2f04d1842c470985ded20fcadcc05a', '182318277735845888', "ORG NOAH13"],
    ['e54cb71b17b9447f91e573c10be9d0a6', '676132795671646212', "cafard werox"],
    ['ebb07b9aae504541ade27ff0dd598c24', '127008827697545216', "MitsuoWrld"],
    ['86e867f186fe4c88a171656e58fc2787', '182273466957926403', "cafard MaxSZN"],
    ['c024a4bc31de4951ba6b13a0dc35fa73', '168713144758185984', "Zkofn"],
    ['e713cd8db2674350b2aec562c655677d', '177908212815728643', "TwitterKvvquyy"],
    ['66ae6e5ee5394aadb904aa7033394160', '268445388271357952', "Ｔａｙｌｏｘ"],
    ['bbcb36a43f364aac85cbcda9bc3aaad6', '671406070194782218', "Vaxa1.x"],
    ['3399dd1f43b44db7aa118500de7b5385', '149917620089401344', "Twitch shika7x"],
    ['fde81ada008e43d09e95b84d3c8d5148', '182273348330426370', "Nirko78"],
    ['41790953227f45178eb4263c893b130a', '517025465920143360', "crr zkǃ"],
    ['8083b9a951f64fa1ad1153775b68ed60', '660533304050606080', "snazYHYH"],
    ['dffcf8fb160946d890a61fe421f09ec5', '281140531474477056', "AUR kyrox"],
    ['20507b02feec4c42b31bc2d95c65b76c', '477892821290946560', "Nicee 7"],
    ['a0c37c7a6cc34dc7821b083d58303837', '215482102366351360', "Sl0wn1x"],
    ['76a8d78f529344ccbfed5b6cbebe196a', '747434533959270405', "ᴱⱽᴼisaacǃツ"],
    ['6c7473ac3e4344a6af6613b418e516db', '407602466159431680', "jokerkiller66613"],
    ['689b20a813ef44debcaea3158f69ce93', '890561921407787008', "Abuzzcomeback."],
    ['c93f248587f94e9f9afd7e3b917d23df', '339820823483355136', "IGLǃ venoxx"],
    ['afe7b90106f64027a2515b33bd536df0', '749326304117030913', "Milow 888"],
    ['038bc5293f3a45e9920a8c039f0bc705', '672509040462413826', "Damjan_RTC"],
    ['45458eda36734ac8a1bea4351fa88a68', '890555294399098880', "Id-_-xv"],
    ['0084af33d6dd45bbb3df5b0b21a5a990', '678913836497014784', "HvK RxZZmoqéquet"],
    ['30f7457b7c74478fa366de2a91eb7703', '545675957327937546', "Lxdupe bää"],
    ['93b9650778d441bc8d741995090f6f02', '403616056725311489', "swizzy the best"],
    ['f18e2ccfd58940eda4e15d86ecc920a1', '686583302424891398', "Sayz ahahahǃ"],
    ['f314cdbc9a5949698be82fcc90109563', '354678694675058691', "Natu_86"],
    ['e8ef97c70ceb42ccb874470a8755f501', '661619380915830791', "1L ryzzen"],
    ['5aed52e753534443abfd5f4fd7aa178d', '169022683231563776', "jarne 66"],
    ['af2af754296541988d0903ec60e5f56b', '229644895759994881', "marley ackerman."],
    ['79313ee827fa422aacd68553bc10bfae', '511230262307217411', "RehanneツLove"],
    ['000b6596771846d4b6d253832eef68cd', '747433341111795723', "kyotaka fv"],
    ['05d2912b50dc49c79b1dd5b5f6099be0', '205001855015686144', "axlsola7"],
    ['d6718323cb67433fb0d0294bb87ae771', '257470731053445120', "3 shelby."],
    ['8bffab1361c548e19e22cdd1cebafd88', '441656846986612736', "Prǃsm Binouch"],
    ['78bf45c37f7c497f9317cc702307ef0a', '816086798076747784', "william_Dz"],
    ['45d2833dcce043649e91138002d55955', '363831434399551488', "Aetite"],
    ['777eb926ccf24547a3a0c0c699a4a0d2', '668422619061559296', "by Tiwan08"],
    ['f2bf0db89e2347b999f883aa27971743', '682661019834650643', "NXS KYROX BÄÄ"],
    ['407092f383974586b5d5cc376e3a0a0b', '888131331752468480', "Raythen_Dragtan5"],
    ['68b5c535b92849c1a80d5778b051fefe', '317189474939408384', "heeeeeeepsi ǃ"],
    ['1b3869061d894446a9742e4527951640', '504345343312281600', "TOP2 FINAL VCCǃ"],
];
